<script>
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";
import useTools from "@/use/Tools";
import {useRecruitmentSourcingStore} from "@/stores/Recruitment/RecruitmentSourcing";

export default {
    props: {
        lockAction: Boolean,
        unlockAction: Boolean,
    },
    setup() {
        const {$route} = useTools();
        const {getBack} = useSharedMethod();
        const {loading, dialog, overlay} = useSharedData();

        const recruitmentSourcingStore = useRecruitmentSourcingStore();

        function update() {
            loading.value = false;
            axios.put(`/recruitmentSourcings/changeStatus/${$route.params.id}`).then(response => {
                recruitmentSourcingStore.updateRecruitmentSourcing(response.data)
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        return {
            loading,
            dialog,
            overlay,
            getBack,
            update
        }
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="500"
    >
        <v-card>
            <w-dialog-toolbar
                :lock-action="lockAction"
                :unlockAction="unlockAction"
            />
            <w-overlay
                :overlay="overlay"
                :loading="loading"
                :lock-action="lockAction"
                :unlockAction="unlockAction"
                @lock="update"
                @unlock="update"
                @cancel="overlay = false"
            />
            <v-card-text>

            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-lock
                    :show="lockAction"
                    :loading="loading"
                    @press="overlay = true"
                />
                <w-btn-unlock
                    :show="unlockAction"
                    :loading="loading"
                    @press="overlay = true"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>

</style>